import type { HttpProvider, HttpRequestConfig } from '@/api/http-provider';

export default abstract class BaseApi {
    protected _provider: HttpProvider;

    protected constructor(provider: HttpProvider) {
        this._provider = provider;
    }

    get provider() {
        return this._provider;
    }

    set provider(provider: HttpProvider) {
        this._provider = provider;
    }

    get<T>(url: string, config?: HttpRequestConfig) {
        return this._provider.get<T>(url, config);
    }

    post<T>(url: string, data?: unknown, config?: HttpRequestConfig) {
        return this._provider.post<T>(url, data, config);
    }

    put<T>(url: string, data?: unknown, config?: HttpRequestConfig) {
        return this._provider.put<T>(url, data, config);
    }

    delete<T>(url: string, config?: HttpRequestConfig) {
        return this._provider.delete<T>(url, config);
    }
}
